import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

const handleResponse = async (response, fallbackMessage) => {
  if (!response.ok) {
    let message = fallbackMessage;
    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      // ignore parse errors
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const fetchProductionActivity = async ({
  preset = "today",
  from = "",
  to = "",
  fromTime = "",
  toTime = "",
  page = 1,
} = {}) => {
  const params = new URLSearchParams({
    preset,
    page: String(page),
    pageSize: "20",
  });
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (fromTime) params.set("fromTime", fromTime);
  if (toTime) params.set("toTime", toTime);

  const response = await fetch(
    `${API_BASE_URL}/production/analytics/activity?${params.toString()}`,
    { headers: authHeaders() }
  );
  return handleResponse(response, "تعذر تحميل تحليل الإنتاج");
};
